import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

export async function getProducts(clientID) {
    let products = [];
    await axios.get(`${apiUrl}/getProducts`, {params: {client_id: clientID}})
        .then(response => {
            products = response.data.products;
        }).catch(console.error);
    return products;
}

export async function addProduct(clientID, productID, productName) {
    let result = {error: true, message: "Unable to add the product"};
    await axios.post(`${apiUrl}/addProduct`, {product_name: productName.trim()}, {params: {client_id: clientID, product_id: productID}})
        .then(response => {
            result.error = (response.data.status === "error");
            result.message = response.data.message;
        }).catch(console.error);
    return result;
}

export function updateProductName(clientID, productID, productName) {
    axios.put(`${apiUrl}/updateProductName`, {product_name: productName.toString().trim()}, {params: {client_id: clientID, product_id: productID}}).catch(console.error);
}

export async function removeProduct(clientID, productID) {
    let result = {error: true, message: "Unable to remove the product"};
    await axios.delete(`${apiUrl}/removeProduct`, {data: {client_id: clientID, product_id: productID}})
        .then(response => {
            result.error = (response.data.status === "error");
            result.message = response.data.message;
        }).catch(console.error);
    return result;
}

export async function searchAddedProductsFromIDs(clientID, productIDs) {
    let products = [];
    await axios.post(`${apiUrl}/searchAddedProductsFromIDs`, {product_id: productIDs}, {params: {client_id: clientID}})
        .then(response => {
            products = response?.data.products || [];
        }).catch(console.error);
    return products;
}

export async function getProductAttributes(clientID, productID) {
    let attributes = [];
    await axios.get(`${apiUrl}/getProductAttributes`, {params: {client_id: clientID, product_id: productID}})
        .then(response => {
            attributes = response?.data.attributes || [];
        }).catch(console.error);
    return attributes;
}

export async function addProductAttribute(clientID, productID, newAttribute) {
    let result = {error: true, message: "Unable to add the attribute"};
    await axios.post(`${apiUrl}/addProductAttribute`, {attribute: newAttribute.toString().trim()}, {params: {client_id: clientID, product_id: productID}})
        .then(response => {
            result.error = (response.data.status === "error");
            result.message = response.data.message;
        }).catch(console.error);
    return result;
}

export async function removeProductAttribute(clientID, productID, attributeName) {
    let result = {error: true, message: "Unable to remove the attribute"};
    await axios.delete(`${apiUrl}/removeProductAttribute`, {data: {client_id: clientID, product_id: productID, attribute: attributeName}})
        .then(response => {
            result.error = (response.data.status === "error");
            result.message = response.data.message;
        }).catch(console.error);
    return result;
}

export async function removeAllProductAttributes(clientID, productID) {
    let result = {error: true, message: "Unable to remove the attributes and their values"};
    await axios.delete(`${apiUrl}/removeAllProductAttributes`, {data: {client_id: clientID, product_id: productID}})
        .then(response => {
            result.error = (response.data.status === "error");
            result.message = response.data.message;
        }).catch(console.error);
    return result;
}

/*export async function getAttributeValues(clientID, productID, attribute) {
    let values = [];
    await axios.get(`${apiUrl}/getAttributeValues`, {params: {client_id: clientID, product_id: productID, attribute: attribute}})
        .then(response => {
            values = response.data.values;
        })
        .catch(console.error);
    return values;
}*/

export async function addAttributeValue(clientID, productID, attributeName, newValue) {
    let result = {error: true, message: "Unable to add the value for the given attribute"};
    await axios.post(`${apiUrl}/addAttributeValue`, {attribute: attributeName, value: newValue.toString().trim()}, {params: {client_id: clientID, product_id: productID}})
        .then(response => {
            result.error = (response.data.status === "error");
            result.message = response.data.message;
        }).catch(console.error);
    return result;
}

export async function removeAttributeValue(clientID, productID, attributeName, valueName) {
    let result = {error: true, message: "Unable to remove the value"};
    await axios.delete(`${apiUrl}/removeAttributeValue`, {data: {client_id: clientID, product_id: productID, attribute: attributeName, value: valueName}})
        .then(response => {
            result.error = (response.data.status === "error");
            result.message = response.data.message;
        }).catch(console.error);
    return result;
}

export async function refreshProductMapping(clientID, productID) {
    let result = {error: true, message: "Unable to refresh the product mapping"};
    await axios.post(`${apiUrl}/refreshProductMapping`, {}, {params: {client_id: clientID, product_id: productID}})
        .then(response => {
            result.error = (response.data.status === "error");
            result.message = response.data.message;
        }).catch(console.error);
    return result;
}
